angular.module('Directives')
.directive('smxOverlay', function($templateCache){
	return {
		restrict: 'E',
		scope: {
			show: '=show', 
		},
		template: $templateCache.get('overlay.html')
  };
});